import React, { Fragment, useEffect, useRef, useState } from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"
import isEmpty from "validator/lib/isEmpty"
import { useDispatch } from "react-redux"
import { FaCheckCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { fetchWalletDetails } from "@redux"
import { Button, TextField } from "components"
import { validateSubscriptionGift } from "services"
import classes from "./TnmwtmSubscriptionGift.module.scss"

const TnmwtmSubscriptionGift = props => {
  const { setOpenTopupModal } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const [code, setCode] = useState("")
  const [sending, setSending] = useState(false)
  const [openCodeValidationModal, setOpenCodeValidationModal] = useState(false)

  const unmount = useRef(false)

  const handleConfirm = () => {
    setCode("")

    setOpenCodeValidationModal(false)
  }

  const validate = () => {
    if (isEmpty(code)) return false

    return true
  }

  const handleValidate = async () => {
    if (!validate()) return

    setSending(true)

    try {

      await validateSubscriptionGift(code)

      if (unmount.current) return

      setOpenCodeValidationModal(true)

      dispatch(
        fetchWalletDetails()
      )
    } catch (err) {
      console.log(err)

      toast.error(t("کد_اعمال_نشد"))
    }

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  return (
    <Fragment>
      <div className={classes["container"]}>
        <TextField
          value={code}
          type="text"
          className={classes["input"]}
          label={t("کد_هدیه_اشتراک")}
          onChange={(e) => setCode(e.target.value)}
        />

        <div className={classes["footer"]}>
          <Button
            color="success"
            className={classes["button"]}
            loading={sending}
            onClick={handleValidate}
          >
            {t("اعمال_کد")}
          </Button>

          <Button
            disabled={sending}
            onClick={() => setOpenTopupModal(false)}
            color="danger"
          >
            {t("بازگشت")}
          </Button>
        </div>
      </div>

      <Modal
        show={openCodeValidationModal}
        onHide={() => setOpenCodeValidationModal(false)}
        backdrop="static"
        centered
      >
        <div className={classes["gift"]}>
          <div className={classes["success"]}>
            <FaCheckCircle
              size={70}
              className={classes["icon"]}
            />
            <div className={classes["text"]}>
              {t("کد_با_موفقیت_اعمال_شد")}
            </div>
          </div>

          <div className={classes["footer-modal"]}>
            <Button
              color="success"
              onClick={handleConfirm}
            >
              {t("تایید")}
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default TnmwtmSubscriptionGift